import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import jwtEncode from "jwt-encode";

const NewCall = () => {

  const { userDetails } = useSelector((state) => state?.userData);
  const UNO_TOKEN = userDetails?.token;

  // Memoize configuration data to prevent recalculation on every render
  const configData = useMemo(() => {
    const storageConfig = localStorage.getItem("configuration");
    return storageConfig ? JSON.parse(storageConfig) : null;
  }, []); // Empty dependency array since localStorage doesn't change during component lifecycle

  const webglUrl = configData?.WEBGL_IFRAME_URL;

  // Memoize JWT token to prevent recalculation on every render
  const jwtToken = useMemo(() => {
    if (!UNO_TOKEN || !configData) return "";
    
    const referrerPayload = {
      UNO_TOKEN: UNO_TOKEN,
      API_URL: configData.API_URL,
      UNO_URL: configData.UNO_URL,
    };
    return jwtEncode(referrerPayload, "");
  }, [UNO_TOKEN, configData]);

  // Memoize iframe src to prevent unnecessary iframe reloads
  const iframeSrc = useMemo(() => {
    return webglUrl ? `${webglUrl}?referrer=${jwtToken}` : "";
  }, [webglUrl, jwtToken]);

  const iframeRef = useRef(null);

  const focusIframe = useCallback(() => {
    try {
      if (iframeRef.current) {
        iframeRef.current.focus();
      }
    } catch (e) {
      // no-op if browser prevents focusing
    }
  }, []);

  useEffect(() => {
    // Focus when the iframe loads the first time
    const node = iframeRef.current;
    if (node) {
      // small delay to ensure it's in the DOM
      setTimeout(focusIframe, 0);
    }

    const handleWindowFocus = () => {
      focusIframe();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        focusIframe();
      }
    };

    const handleOutsideClick = (event) => {
      if (!iframeRef.current) return;
      if (event.target === iframeRef.current) return;
      // If click is outside the iframe, re-focus it
      setTimeout(focusIframe, 0);
    };

    window.addEventListener("focus", handleWindowFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("mousedown", handleOutsideClick, true);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("mousedown", handleOutsideClick, true);
    };
  }, [focusIframe]);

  // Memoize the iframe element to prevent recreation on every render
  const iframeElement = useCallback(() => {
    if (!webglUrl) return null;
    
    return (
      <iframe 
        allow="microphone *; camera *; display-capture *" 
        allowFullScreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen"
        msallowfullscreen="msallowfullscreen"
        oallowfullscreen="oallowfullscreen"
        webkitallowfullscreen="webkitallowfullscreen" 
        ref={iframeRef}
        tabIndex={0}
        src={iframeSrc} 
        frameBorder="0"
        style={{ width: '100%', height: '100%' }}
      />
    );
  }, [webglUrl, iframeSrc]);

  return (
    <>
    {console.log("RERENDER")}
      <div className="xp-breadcrumbbar remoteiframe">
        <div className="card">
          {iframeElement()}
        </div>
      </div>
    </>
  );
};

export default NewCall;
